module.exports = __webpack_public_path__ + "serverless.7bc598.svg";